/**
 * Created by haikuan.gu@qunar.com
 * Date: 2020/5/25
 * Time: 9:51 下午
 *
 */
import Ext from './core';
import './redux';
import './router'; // 配置全局插件

Ext.defaults.globalPlugins = ['redux', 'router'];
export default Ext;